// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"dcb5718d","96":"3a1159fa","328":"845f4f00","436":"61b983bf","624":"b454fc04","760":"1460a014"}[chunkId] + ".chunk.js";
};